"use strict";

angular.module("vendor")
.controller("SectionImport", function(
    $scope, FlashBag, gettextCatalog, Catalog, CatalogEntryService, CatalogSharing, PartnershipService
) {
    this.catalogService = Catalog;
    this.catalogEntryService = CatalogEntryService;
    this.catalogSharingService = CatalogSharing;
    this.preferredService = PartnershipService;

    this.importCallBack = function() {
        FlashBag.info(gettextCatalog.getString("The import of your products will begin shortly. You'll receive an email when the process will be done."));
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/import/import.controller.js
// module id = 1009
// module chunks = 0